export const hasAllowedModels = (allowedModels) => {
  if (Array.isArray(allowedModels)) {
    return allowedModels.length > 0;
  }

  if (allowedModels && typeof allowedModels === "object") {
    return Object.keys(allowedModels).length > 0;
  }

  return Boolean(allowedModels);
};

export const getAnalysisAvailability = ({ availableReports, language, selectedReport, t }) => {
  if (!selectedReport) {
    return {
      isAvailable: true,
      code: "",
      message: "",
    };
  }

  const selectedAiReport = availableReports?.aiAnalysis?.find(
    (report) => report.ReportKey === selectedReport
  );

  if (hasAllowedModels(selectedAiReport?.AllowedModels)) {
    return {
      isAvailable: true,
      code: "",
      message: "",
      allowedModels: selectedAiReport.AllowedModels,
      selectedAiReport,
    };
  }

  return {
    isAvailable: false,
    code: "analysis_unavailable",
    message: t(
      "reports.analysisUnavailableContactSupport",
      language === "en"
        ? "AI analysis is currently unavailable for this report. Please contact support."
        : "هذا التقرير غير متاح للتحليل الذكي حاليًا. يرجى التواصل مع الدعم."
    ),
    allowedModels: null,
    selectedAiReport: selectedAiReport || null,
  };
};
